import React, { useState } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db, functions } from "../firebase";
import { httpsCallable } from "firebase/functions";

type Status = "idle" | "loading" | "success" | "error";

// Cloud Function
const createCheckoutSession = httpsCallable(
  functions,
  "createCheckoutSession"
);

// Load price ID from environment
const PRICE_ID = "price_1RYFS1HHZ1N93iDpe4rNzTSf";
console.log("Loaded Stripe Price ID (hardcoded):", PRICE_ID);

export default function SignupForm() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [pickupDay, setPickupDay] = useState("");
  const [status, setStatus] = useState<Status>("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    try {
      if (!PRICE_ID) {
        throw new Error(
          "Stripe price ID missing. Add VITE_STRIPE_PRICE_ID to your .env.local."
        );
      }


      // Save signup to Firestore
      await addDoc(collection(db, "signups"), {
        name,
        email,
        pickupDay,
        createdAt: new Date(),
      });

      // Instead of direct Stripe checkout, redirect user to subscription options page
      setStatus("success");
      window.location.assign("/subscribe");
    } catch (err: any) {
      console.error("Signup error:", err);
      setStatus("error");
      setErrorMsg(err?.message || "Something went wrong.");
    }
  };

  return (
    <form className="form" onSubmit={handleSubmit}>
      <label htmlFor="signup-name">Full name
        <input
          id="signup-name"
          name="name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="e.g. Jane Doe"
          required
          autoComplete="name"
        />
      </label>

      <label htmlFor="signup-email">Email
        <input
          id="signup-email"
          name="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="e.g. jane@example.com"
          type="email"
          required
          autoComplete="email"
        />
      </label>

      <label htmlFor="signup-pickup-day">Preferred pickup day
        <select
          id="signup-pickup-day"
          name="pickupDay"
          value={pickupDay}
          onChange={(e) => setPickupDay(e.target.value)}
          required
          autoComplete="off"
        >
          <option value="">Select…</option>
          <option>Monday</option>
          <option>Tuesday</option>
          <option>Wednesday</option>
          <option>Thursday</option>
          <option>Friday</option>
        </select>
      </label>

      <button
        className="btn btn-primary"
        type="submit"
        disabled={status === "loading"}
      >
        {status === "loading" ? "Working…" : "Get started"}
      </button>

      {status === "error" && (
        <div className="small" style={{ color: "#b91c1c" }}>
          ❌ {errorMsg}
        </div>
      )}

      {status === "success" && (
        <div className="small" style={{ color: "#3182ce" }}>
          ✅ Signup successful! Please <a href="/subscribe" style={{ color: "#3182ce", textDecoration: "underline" }}>choose a subscription plan</a>.
        </div>
      )}
    </form>
  );
}